<template>
<div class="chapter">
<div class="inner_page">
<p class="C204"><a id="page_XXIV"><img alt="" class="Image151" src="img/25_1.png" width="60%"/></a></p><a id="page_XXIV">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Map_of_Texas.vue?0e3f0d36